import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PriceDifferenceService } from './price-difference.service';
import { IPriceValues } from './IPrice-difference';

@Component({
    selector: 'price-diff',
    template: `
        <span [innerHTML]="sum | price:values.currency" *ngIf="!isOnlyDiff"></span>
        <span [class]="inverted ? 'negative': 'positive'" *ngIf="difference">+</span>
        <span [ngClass]="class"
              *ngIf="difference"
              [innerHTML]="difference | price:values.currency">
        </span>
    `,
    styles: [`
        .positive {
          color: #8a1f11;
        }
        .negative {
          color: #00B050;
        }
    `]
})
export class PriceDifferenceComponent extends PriceDifferenceService implements OnInit, OnChanges {
    @Input()
    public values: IPriceValues;
    @Input()
    public inverted: boolean = false;
    @Input()
    public isOnlyDiff: boolean = false;

    public difference: number = 0;
    public sum: number = 0;
    public class: string;

    public writeClass(): string {
        if(this.inverted){
            return this.isPositive(this.difference) ? 'negative' : 'positive';

        }
        return this.isPositive(this.difference) ? 'positive' : 'negative';
    }
    public ngOnChanges(changes: SimpleChanges): void {
        this.difference = (!this.values.calculateDifference) ?
            this.values.difference :
            this.calculateDifference(this.values.base, this.values.difference, this.inverted);

        this.sum = (!this.values.calculateSum) ?
            this.values.base :
            this.sumValues(this.values.base, this.difference);
        this.class = this.writeClass();
    }


    public ngOnInit(): void {

    }
}
